<script>
  import { onMount, onDestroy } from "svelte";
  export let images = [];
  export let delay = 3000;
  export let compact = null;

  let swiperEl;
  let swiperInstance;
  function loadSwiper() {
    return new Promise((resolve) => {
      if (window.Swiper) return resolve();
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      script.onload = resolve;
      document.head.appendChild(script);
    });
  }
  onMount(async () => {
    await loadSwiper();
    swiperInstance = new Swiper(swiperEl, {
      loop: true,
      autoplay: {
        delay,
        disableOnInteraction: false,
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },
    });
  });
  onDestroy(() => {
    if (swiperInstance) swiperInstance.destroy();
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"
  />
</svelte:head>

<div class="swiper" class:compact bind:this={swiperEl}>
  <div class="swiper-wrapper">
    {#each images as { src, alt }, i}
      <div class="swiper-slide">
        <div class="slide-bg" style="background-image: url('{src}')"></div>
        <img {src} alt={alt ?? `Slide ${i + 1}`} />
      </div>
    {/each}
  </div>
  <div class="swiper-pagination"></div>
  <div class="swiper-button-next"></div>
  <div class="swiper-button-prev"></div>
</div>

<style>
  .swiper {
    width: 100%;
    height: 56.25vw;
    border-radius: 12px;
    overflow: hidden;
  }

  @media (min-width: 768px) {
    .swiper {
      height: 42.85vw;
    }
  }

  @media (min-width: 1024px) {
    .swiper {
      height: 33.33vw;
    }
  }

  /* Compact mode — always cover, always square-ish, no responsive height changes */
  .swiper.compact {
    height: 100%;
    border-radius: 0;
  }

  .swiper.compact .slide-bg {
    display: none;
  }

  .swiper.compact .swiper-slide img {
    object-fit: cover;
  }

  .swiper-slide {
    position: relative;
    height: 100%;
    overflow: hidden;
  }

  .slide-bg {
    position: absolute;
    inset: -20px;
    background-size: cover;
    background-position: center;
    filter: blur(18px) brightness(0.9) saturate(1.6);
    transform: scale(1.1);
    z-index: 0;
  }

  .swiper-slide img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    z-index: 1;
  }

  @media (max-width: 767px) {
    .slide-bg {
      display: none;
    }

    .swiper-slide img {
      object-fit: fill;
    }
  }
</style>
